export const schoolApplicationRequestData = [
  {
    requestStatus: "new",
    studentName: "عبدالله سعود",
    studentNameEn: "Abdullah saud",
    studentID: "10958473164",
    phoneNumber: "0551233214",
    educationLevel: "الصف الأول متوسط",
    educationLevelEn: "First Intermediate stage",
  },
  {
    requestStatus: "accepted",
    studentName: "عبدالله سعود",
    studentNameEn: "Abdullah saud",
    studentID: "10958473164",
    phoneNumber: "0551233214",
    educationLevel: "الصف الأول متوسط",
    educationLevelEn: "First Intermediate stage",
  },
  {
    requestStatus: "rejected",
    studentName: "عبدالله سعود",
    studentNameEn: "Abdullah saud",
    studentID: "10958473164",
    phoneNumber: "0551233214",
    educationLevel: "الصف الأول متوسط",
    educationLevelEn: "First Intermediate stage",
  },
];
